import { render, staticRenderFns } from "./frequencyDistributionForMicrobe.vue?vue&type=template&id=1f081cbc&scoped=true&"
import script from "./frequencyDistributionForMicrobe.vue?vue&type=script&lang=js&"
export * from "./frequencyDistributionForMicrobe.vue?vue&type=script&lang=js&"
import style0 from "./frequencyDistributionForMicrobe.vue?vue&type=style&index=0&id=1f081cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f081cbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VFlex,VLayout,VOverlay,VProgressCircular,VRow})
